import React from 'react'
// import { useContext, useEffect } from 'react';
export const About = () => {
  return (
    <h2>This is a web based notebook app where you can create, update and delete your notes. The best part is that you can access your notes from any devices with stable internet connection. </h2>
  )
}
